module.exports = "/_next/static/images/ev-appartments-429c54fbbd596e3d63389dd662aa1753.jpg.webp";